<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<div [formGroup]="parentFormGroup">
	<div formArrayName="socialMediaList">
		<div
			class="flex-layout-row flex-layout-align-start-center"
			*ngFor="let socialMedia of formArray.controls; let i = index"
			[formGroupName]="i"
		>
			<div class="social-media-checkbox">
				<mat-checkbox formControlName="included" [tabIndex]="startTabIndex + i"></mat-checkbox>
			</div>
			<div class="social-media-url">
				<mat-form-field>
					<mat-label>{{ socialMedia.value.name }} URL</mat-label>
					<input formControlName="url" matInput [tabIndex]="startTabIndex + i + 1" />
					<mat-error *ngIf="socialMedia.get('url').touched && socialMedia.get('url').errors?.required">
						{{ socialMedia.value.name }} URL is required
					</mat-error>
					<mat-error
						*ngIf="socialMedia.get('url').touched && socialMedia.get('url').errors?.maxlength && !socialMedia.get('url').errors?.pattern"
					>
						{{ socialMedia.value.name }} URL must be no more than 200 characters
					</mat-error>
					<mat-error *ngIf="socialMedia.get('url').touched && socialMedia.get('url').errors?.pattern">
						{{ socialMedia.value.name }} URL must be a correctly formatted website URL
					</mat-error>
				</mat-form-field>
			</div>
		</div>
	</div>
</div>
